var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKirkosMerchantArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.40314L0.875091 16.2813L0.875091 0.525022L18.5 8.40314Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKirkosMerchantArrow);
export default __webpack_public_path__ + "static/media/kirkos_merchant_arrow.38347f3347a1b82b2c8ef30dbdaacea9.svg";
export { ForwardRef as ReactComponent };